var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-error"},[(_vm.icon)?_c('i',{class:`icon-${_vm.icon}`,style:({ color: _vm.iconColor })}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.errorText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }